import type { CSSProperties, JSX } from 'react';
import {
  DatePickerInput,
  type DatePickerInputProps,
} from '@mantine/dates';
import './FinanceDateRangeInput.css';

export type FinanceDateRangeInputProps = Omit<
  DatePickerInputProps<'range'>,
  'type'
>;

const defaultStyle: CSSProperties = { width: 218 };

/**
 * Диапазон дат для финансовых экранов (admin / admin-seller): одинаковые размеры и формат.
 */
export function FinanceDateRangeInput({
  placeholder = 'Выберите даты',
  size = 'xs',
  valueFormat = 'YYYY-MM-DD',
  clearable = true,
  style,
  className,
  ...rest
}: FinanceDateRangeInputProps): JSX.Element {
  return (
    <DatePickerInput
      type="range"
      placeholder={placeholder}
      size={size}
      valueFormat={valueFormat}
      clearable={clearable}
      className={['finance-date-range', className].filter(Boolean).join(' ')}
      style={{ ...defaultStyle, ...style }}
      {...rest}
    />
  );
}
